import React from 'react';
import { Route } from 'react-router-dom';

import Cancel from '../../components/info/Cancel';
import Privacy from '../../components/info/Privacy';
import Term from '../../components/info/Term';

import * as PATH from './path';
import TEXT from '../text/textSalesBabyface.json';

export const InfoPageRoutes = () => (
  <>
    <Route path={PATH.INFO_PRIVACY} render={() => <Privacy />} />
    <Route path={PATH.INFO_TERM} render={() => <Term />} />
    <Route path={PATH.INFO_CANCEL} render={() => <Cancel />} />
  </>
);

export const INFO_ROUTE = [
  {
    title: '개인정보처리방침',
    path: PATH.INFO_PRIVACY,
  },
  {
    title: '이용약관',
    path: PATH.INFO_TERM,
  },
  {
    title: TEXT.titleRefund,
    path: PATH.INFO_CANCEL,
  },
];
